._illustration_1jwc6_1 {
  border-radius: 8px;
  box-shadow: 0 0 9px 1px rgba(0, 0, 0, 0.1);
  border: 5px solid #fff;
  height: 70px;
  width: 70px;
  box-sizing: border-box; }
